export const GET_DISCOVER = "GET_DISCOVER";
export const GET_DISCOVER_SUCCESS = "GET_DISCOVER_SUCCESS";
export const GET_DISCOVER_FAIL = "GET_DISCOVER_FAIL";

const initialState = {
  data: [],
  loading: false,
  hasError: false,
  messageError: "",
};

export default function discover(state = initialState, action) {
  switch (action.type) {
    case GET_DISCOVER: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_DISCOVER_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    }

    case GET_DISCOVER_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
    default:
      return state;
  }
}

export function getDiscover() {
  return {
    type: GET_DISCOVER,
    payload: {
      request: {
        url: "Favorite/Discover",
      },
    },
  };
}
